import { CLASS_NOTE_PRINT_SECTIONS } from "utils/classNotes";

export const CONTENT_PREVIEW_PRINT_SECTION = {
  key: "contentPreview",
  defaultLabel: "Content Preview",
  defaultActive: true,
};

export const createDefaultPrintSections = () => {
  const sections = {};
  CLASS_NOTE_PRINT_SECTIONS.forEach(({ key, defaultLabel, defaultActive }) => {
    sections[key] = { active: defaultActive, name: defaultLabel };
  });
  sections[CONTENT_PREVIEW_PRINT_SECTION.key] = {
    active: CONTENT_PREVIEW_PRINT_SECTION.defaultActive,
    name: CONTENT_PREVIEW_PRINT_SECTION.defaultLabel,
  };
  return sections;
};

const normalizePrintSections = (savedSections = {}) => {
  const defaults = createDefaultPrintSections();
  const classNoteSections = CLASS_NOTE_PRINT_SECTIONS.reduce((sections, { key, defaultLabel }) => {
    const savedSection = savedSections[key] || {};
    sections[key] = {
      active: typeof savedSection.active === "boolean" ? savedSection.active : defaults[key].active,
      name: defaultLabel,
    };
    return sections;
  }, {});
  const savedContentPreviewSection = savedSections[CONTENT_PREVIEW_PRINT_SECTION.key] || {};

  return {
    ...classNoteSections,
    [CONTENT_PREVIEW_PRINT_SECTION.key]: {
      active: typeof savedContentPreviewSection.active === "boolean"
        ? savedContentPreviewSection.active
        : defaults[CONTENT_PREVIEW_PRINT_SECTION.key].active,
      name: CONTENT_PREVIEW_PRINT_SECTION.defaultLabel,
    },
  };
};

export const loadPrintSections = () => {
  try {
    const saved = localStorage.getItem("printView_sections");
    if (saved) {
      const parsed = JSON.parse(saved);
      return normalizePrintSections(parsed);
    }
  } catch (error) {
    // ignore invalid storage
  }
  return createDefaultPrintSections();
};

export const savePrintSections = (sections) => {
  localStorage.setItem("printView_sections", JSON.stringify(sections));
};

export const loadBoxVisibilityForClass = (classId, boxes = []) => {
  if (!classId) return {};
  try {
    const saved = localStorage.getItem(`printView_boxVisibility_${classId}`);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    // ignore invalid storage
  }
  const defaults = {};
  boxes.forEach((box, index) => {
    defaults[index] = box?.show !== false;
  });
  return defaults;
};

export const saveBoxVisibilityForClass = (classId, visibilityMap) => {
  if (!classId) return;
  localStorage.setItem(`printView_boxVisibility_${classId}`, JSON.stringify(visibilityMap));
};

export const PRINT_QUEUE_MAX_ITEMS = 60;

export const createPrintQueueItem = (classId, dateKey, className = "") => ({
  id: `${classId}-${dateKey}`,
  classId,
  dateKey,
  className,
});

export const loadPrintQueue = () => {
  try {
    const saved = sessionStorage.getItem("printView_queue");
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    // ignore invalid storage
  }
  return [];
};

export const savePrintQueue = (queue) => {
  sessionStorage.setItem("printView_queue", JSON.stringify(queue));
};
